module.exports = {"141127100":"东村镇","141127101":"岚城镇","141127102":"普明镇","141127103":"界河口镇","141127201":"上明乡","141127202":"王狮乡","141127203":"梁家庄乡","141127204":"顺会乡","141127206":"社科乡","141127400":"岚县普明工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141127.json
// module id = 473
// module chunks = 0